import React, { useEffect } from 'react'
import { HStack, Text } from '@chakra-ui/react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as eva from 'eva-icons'
import './MenuItem.css'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearSearchToken as clearUserSearchToken } from '../../store/slices/userSearchSlice'
import { clearSearchToken as clearEventSearchToken } from '../../store/slices/eventSearchSlice'

interface IMenuItemProps {
  icon: string
  label: string
  borderTopRadius: string
  borderBottomRadius: string
  to: string
  isSelected: boolean
}

function MenuItem({ icon, label, borderTopRadius, borderBottomRadius, to, isSelected }: IMenuItemProps): JSX.Element {
  useEffect(() => eva.replace())
  const dispatch = useDispatch()
  return (
    <Link
      to={to}
      onClick={(): void => {
        dispatch(clearUserSearchToken())
        dispatch(clearEventSearchToken())
      }}>
      <HStack
        spacing='16px'
        padding={'20px'}
        borderBottomRadius={borderBottomRadius}
        borderTopRadius={borderTopRadius}
        cursor='pointer'
        width={'242px'}
        height={'61px'}
        bg={isSelected ? 'neutralDark' : '#FFFFFF'}
        color={isSelected ? '#FFFFFF' : '#222B45'}
        _hover={{ bg: 'neutralDark', color: '#FFFFFF' }}
        className={isSelected ? 'menu-item-selected' : 'menu-item'}
        fontSize='16px'
        fontWeight='600'
        lineHeight='22.4px'
        textAlign='left'>
        <i data-eva={icon} className={'eva-icon'} />
        <Text fontSize='lg'>{label}</Text>
      </HStack>
    </Link>
  )
}

export { MenuItem }
